module.exports = __webpack_public_path__ + "static/media/menu.8981a1fe.svg";